"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntitySpec = exports.castEntities = exports.EntitySpecSchema = void 0;
var ajv_1 = __importDefault(require("ajv"));
var common_1 = require("./common");
// EntitySpec schema in json-schema format
exports.EntitySpecSchema = {
    type: "object",
    properties: __assign(__assign({}, common_1.BaseSpecSchema.properties), { singular: { type: "string" }, plural: { type: "string" } }),
    required: __spreadArrays(common_1.BaseSpecSchema.required, ["singular", "plural"]),
};
var ajv = new ajv_1.default();
var validateArray = ajv.compile({ type: "array", items: exports.EntitySpecSchema });
// Cast an array of EntitySpecs
exports.castEntities = function (items) {
    var valid = validateArray(items);
    if (!valid)
        throw new Error(JSON.stringify(validateArray.errors));
    return items.map(function (item) { return new EntitySpec(item); });
};
// EntitySpec class
var EntitySpec = /** @class */ (function (_super) {
    __extends(EntitySpec, _super);
    function EntitySpec(inner) {
        var _this = _super.call(this, inner) || this;
        // Basic getters
        _this.getSingular = function () { return _this.entity.singular; };
        _this.getPlural = function () { return _this.entity.plural; };
        // keep inner object for later use
        _this.entity = inner;
        return _this;
    }
    return EntitySpec;
}(common_1.BaseSpec));
exports.EntitySpec = EntitySpec;
